const SDK_VERSION = '8.34.0-internal.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
